// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-container{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%}.login-container .title{color:#6e47ff}.login-form-container{max-width:360px;width:100%;padding:1rem;text-align:left;color:#17006e}.tradique-primary-btn{background-color:#17006e;color:#fff}.tradique-primary-btn:hover{background-color:#6e47ff;color:#fff}", ""]);
// Exports
module.exports = exports;
